import styled from "styled-components";
import { CommmonBoxLayout, CommonBoxTitle, CommonLayout, SearchBox, TableLayout } from "../style/common";
import { flex, flexBetweenCenter, flexCenterCenter } from "../style/mixins";
import Search from "../components/common/Search";
import { userTheadArr } from "../constants/TheadConst";
import Table from "../components/common/Table";
import { gnbConst } from "../constants/gnbConst";
import { useNavigatePage } from "../hooks/useNavigatePage";
import { useEffect, useState } from "react";
import { statsAllDateStart } from "../constants/dateConst";
import useFormattedDate from "../hooks/useFormattedDate";
import { statsNum } from "../api/stats";
import { memberList } from "../api/member";
import { Spinner } from "../components/common/Spinner";
import Paging from "../components/common/paging";
import { useMemberStore } from "../store/memberStore";

export default function User() {
  const { onMovementPage } = useNavigatePage();
  const { memberPermitLevel } = useMemberStore();
  const pageTitle = gnbConst[1].title;
  const toDay = useFormattedDate({});
  const [allUser, setAllUser] = useState(0);
  const [cancelUser, setCancelUser] = useState(0);
  const [userList, setUserList] = useState<MemberListResponse>();
  const [userListStartNum, setUserListStartNum] = useState(1);
  const [searchVal, setSearchVal] = useState("");
  const [pagingVal, setPagingVal] = useState(1);

  const publicExtrasVal = (public_extras: string, key: string) => {
    const val = JSON.parse(public_extras)[key]
    return val ? val : "-";
  }

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => { 
    const {
        target: { name, value },
    } = e;
    
    if (name === "search") {
      setSearchVal(value);
    } 
  };

  const onMoveDetil = (idx: string) => {
    onMovementPage(`/user/detail/${idx}`);
  };

  const onPageChange = (page: number) => {
    setPagingVal(page);
  };

  useEffect(() => {
    if (gnbConst[0].level > memberPermitLevel) {
      alert("접근 권한이 없습니다.");
      onMovementPage(-1);
    }
  }, [memberPermitLevel]);

  // 통계 data
  useEffect(() => {
    const fetchUserStats = async () => {
      const params = {
        stats_date_start: statsAllDateStart,
        stats_date_end: toDay.replaceAll("-", "") + "24",
      }
      
      try {
        const allParmas = { ...params, stats_idx: process.env.REACT_APP_STATS_IDX_ALL_URE as string };
        const cancelParmas = { ...params, stats_idx: process.env.REACT_APP_STATS_IDX_CANCEL_USE as string }
        const [allResponse, cancleResponse] = await Promise.all([
          statsNum(allParmas),
          statsNum(cancelParmas),
        ]);
  
        setAllUser(allResponse.data.value);
        setCancelUser(cancleResponse.data.value);
      }
      catch (error: any) {
      }
    }
    
    fetchUserStats();
  }, [toDay]);

  // 유저 리스트
  useEffect(() => {
    const fetchUserList = async () => {
      try {
        const params = { page_index: pagingVal, page_size: 10, search_field: "member_id, member_name, member_public_extras", search: searchVal };
        const response = await memberList(params);
        let index = 1;
        if (response.page && response.page.page_index) {
          index = response.page.page_index * 10 - 10 + 1; 
        }
        
        setUserList(response);
        setUserListStartNum(index);
      }
      catch (error: any) {}
    }

    fetchUserList();
  }, [searchVal, pagingVal]);
  
  return (
    <CommonLayout>
      <CommmonBoxLayout>
        <CommonBoxTitle>{pageTitle}</CommonBoxTitle>

        <SearchBoxCustom>
          <SpaceBox>
            <UserNumBox $bgcColor="#F8CA82" $numColor="#F19505">
              <p>{allUser}</p>
              <div>총회원수</div>
            </UserNumBox>

            <UserNumBox $bgcColor="#D0D5DA" $numColor="#959FAA">
              <p>{cancelUser}</p>
              <div>탈퇴</div>
            </UserNumBox>
          </SpaceBox>

          <SpaceBox>
            <Search value={searchVal} onChange={onSearchChange} placeholder="전체 검색 (휴대폰 번호 제외)" />
            {/* <Btn
              type="button"
              title="회원추가"
              color="skyBlue"
              size="lg"
              onClick={() => onMovementPage("/user/detail/add")}
            /> */}
          </SpaceBox>
        </SearchBoxCustom>
        {userList ? (
          <TableLayout>
            <Table thead={userTheadArr}>
              {userList.list.map((obj, i) => (
                <TrPointer key={obj.idx} onClick={() => onMoveDetil(obj.idx)}>
                  <td>{userListStartNum + i}</td>
                  <td>{obj.member_id}</td>
                  <td>{obj.member_name}</td>
                  <td>{obj.member_phone?.replace("+82", "0") || "-"}</td>
                  <td>{obj.member_public_extras ? publicExtrasVal(obj.member_public_extras, "com") : "-"}</td>
                  <td>{obj.member_public_extras ? publicExtrasVal(obj.member_public_extras, "sub") : "-"}</td>
                  <td>
                    {obj.member_public_extras ? publicExtrasVal(obj.member_public_extras, "com_email") : "-"}
                    <br />
                    {obj.member_public_extras ? publicExtrasVal(obj.member_public_extras, "sub_email") : "-"}
                  </td>
                  <td>{obj.is_active === 0 ? "탈퇴" : "-"}</td>
                </TrPointer>
              ))}
            </Table>
            <Paging
              pageIndex={pagingVal}
              totalPage={userList.page?.total_page ? userList.page.total_page : 0}
              onPageChange={onPageChange}
            />
          </TableLayout>
        ) : <Spinner />}
      </CommmonBoxLayout>
    </CommonLayout>
  );
}

const SearchBoxCustom = styled(SearchBox)`
  ${flexBetweenCenter};
`;

const SpaceBox = styled.div`
  ${flex};
  gap: 0.625rem;
`;

const UserNumBox = styled.div<{ $bgcColor: string; $numColor: string; }>`
  color: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  background-color: ${({ $bgcColor }) => $bgcColor};
  width: 7.625rem;
  height: 2.5rem;
  border-radius: 0.625rem;
  overflow: hidden;
  ${flex};

  > p {
    background-color: ${({ $numColor }) => $numColor};
    width: 2.75rem;
    height: 100%;
    border-radius: 0.625rem;
    ${flexCenterCenter};
  }

  > div {
    width: calc(100% - 2.75rem);
    height: 100%;
    ${flexCenterCenter};
  }
`;

const TrPointer = styled.tr`
  cursor: pointer;
`;